import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/biz/app-feedback/page',
    method: 'get',
    params
  })
}

export function addObj(data) {
  return request({
    url: '/biz/app-feedback/add',
    method: 'post',
    data
  })
}
export function putObj(data) {
  return request({
    url: '/biz/app-feedback/edit',
    method: 'post',
    data
  })
}
export function delObj(data) {
  return request({
    url: '/biz/app-feedback/delete',
    method: 'post',
    data
  })
}
export function getObj(id) {
  return request({
    url: '/biz/app-feedback/detail',
    method: 'get',
    params: { id }
  })
}
export function putStatus(data) {
  return request({
    url: '/biz/app-feedback/update',
    method: 'post',
    data
  })
}
